import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { trigger, transition, style, animate, AnimationEvent } from '@angular/animations';
import { AppInfoComponent } from '../../myapps/app-info/app-info.component';
import { AppService } from 'src/app/services/app/app.service';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from "../../../layout/spinner/spinner.component";
import { LanguagesService } from 'src/app/services/languages/languages.service';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-setup-app',
  standalone: true,
  imports: [AppInfoComponent, CommonModule, SpinnerComponent],
  templateUrl: './setup-app.component.html',
  styleUrls: ['./setup-app.component.css'],
})
export class SetupAppComponent {
  id = 0;
  currentComponent: string = '';
  isFinishing = false;

  checkPayLoad = false
  selectedLanguage: any

  // Form Groups for each step
  languageForm: FormGroup;
  infoForm: FormGroup;
  contactForm: FormGroup;


  loadPay = false

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private AppService: AppService,
    private languageService: LanguagesService,
    private ThemeService: ThemeService,
    private modalService: NgbModal
  ) {

    this.activatedRoute.params.subscribe(
      params => {
        if (params['id']) {
          this.id = +params['id'];
        }
      }
    );

    this.languageService.selectedLanguage$.subscribe((language) => {
      this.selectedLanguage = language;
    });

    this.checkPey()
  }


  checkPey(){
      this.modalService.dismissAll();
    this.checkPayLoad = true
    this.AppService.checkPay(this.id).subscribe(
      (res: any) => {
        this.checkPayLoad = false
        console.log('res: ', res)
        if(res.message == 'app.unpaid'){
          // alert('გადაუხდელია')
          this.pey(res.data)

        }
      },
      (error: any) => {
        this.checkPayLoad = false

        console.log(error)
        // this.router.navigate(['/']);
      }
    )
  }

  close() {
    this.router.navigate(['/']);
  }



  pey(data: any){

    this.loadPay = true;

    data.currency = 'GEL'
    data.language = 'ka'

    console.log(data)

    if(this.selectedLanguage.code !== 'ka_GE') {
      data.language = 'en'
    }

    data.theme = this.ThemeService.getThemes()
    

    if(data.package == 'minimal') {
      data.total_amount = 0
    }else{
     data.total_amount = 1
    }
 
    // this.data.selectedMonths = this.selectedMonths
    data.selectedMonths = '1'

    console.log(data)

    this.AppService.pey(data).subscribe(
      (res: any) => {
        this.loadPay = false;
        console.log('res from setup: ', res)
        if (res && res.payment_url) {
          // const paymentUrl = res.payment_url + '&theme=' + this.ThemeService.getThemes();
          const paymentUrl = res.payment_url;
          window.location.href = paymentUrl; // გადამისამართება იმავე ფანჯარაში
        } else {
          console.error('Payment URL not found in response:', res);
        }
      },
      (err) => {
        this.loadPay = false;
        console.error('Payment request failed:', err);
      }
    );
  }





}